import { registerEventHandlers } from "@/bl-events"

import "@/modules/base"
import "@/modules/legacy"
import "@/modules/scroll-to-anchor"
import { setWdyhauTrafficCookie } from "@/modules/wdyhau-survey"
import { eventHandlers as abTestEventHandlers } from "@/modules/abtest-toggle"
import { eventHandlers as categoryExplorerEventHandlers } from "@/features/category-explorer/init"

import "@/features/animate/init"
import "@/features/app-reviews/init"

// Timeline CSS (non-scoped global styles extracted from Vue components)
import "@/shared/timeline.vue"
import "@/features/trial-duration-explanation/components/trial-timeline-with-reminder-step.vue"

import "@/styles/partner-page"

registerEventHandlers([categoryExplorerEventHandlers, abTestEventHandlers])

setWdyhauTrafficCookie()
